import datepicker from 'js-datepicker';

if (document.querySelector('.arrival-datepicker')) {
    const arrival = datepicker('.arrival-datepicker', {
        id: 'dateRange',
        minDate: new Date()
    });
    const departure = datepicker('.departure-datepicker', { id: 'dateRange' });
}